import { PROVINCE_OPTIONS } from '@myap/metadata';
import { SelectField } from '../../forms/FormikFields';
import { FIELD_PROVINCE } from '../constants';
function SelectProvince(_ref) {
  var values = _ref.values,
    isCurrentYear = _ref.isCurrentYear,
    disabled = _ref.disabled,
    setFieldValue = _ref.setFieldValue;
  var hasProvinceOptions = Object.keys(PROVINCE_OPTIONS).some(function (p) {
    return p === values.countryCode;
  });
  if (hasProvinceOptions && isCurrentYear) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectField, {
      label: "Select your location below",
      required: true,
      name: FIELD_PROVINCE,
      options: PROVINCE_OPTIONS[values.countryCode],
      onChange: function onChange(val) {
        return setFieldValue(FIELD_PROVINCE, val);
      },
      disabled: disabled
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-spacerv-24"
    }));
  }
  return null;
}
export default SelectProvince;